export enum AnalyticsScreenType {
  Web = 'web',
  Native = 'native',
}

export enum AnalyticsAuthType {
  UserValid = 'auth_user_valid',
  Error = 'auth_',
  UnknownError = 'auth_unknown_error',
}

export enum AnalyticsNavigateMbButtonType {
  Main = 'main',
  Bottom = 'bottom',
}

export enum AnalyticsConditionsType {
  Landing = 'rules_landing',
  Mb = 'rules_mb',
  CopyMb = 'copy_rules_mb',
}

export enum AnalyticsNavBarButtonType {
  Bonuses = 'bonuses',
  Statistics = 'your_statistics',
  Faq = 'faq',
}

export enum AnalyticsBackButtonType {
  Candy = 'candy',
  Bonuses = 'bonuses',
  Faq = 'faq',
}

export enum AnalyticsScrollToItemButtonType {
  Main = 'main',
  UserStatistics = 'your_statistics',
  UserStatisticsFull = 'your_statistics_full',
}

export enum AnalyticsItemBonusType {
  Bonus = 'bonus',
  Wish = 'wish',
}

export enum AnalyticsItemStateType {
  New = 'new',
  Open = 'open',
}

export enum AnalyticsBonusButtonType {
  More = 'more',
  Copy = 'copy',
  ToProduct = 'to_product',
}

export enum AnalyticsBonusSwitchButtonType {
  MyBonuses = 'my_bonuses',
  OtherBonuses = 'other_bonuses',
}

export enum AnalyticsNotificationsStateType {
  On = 'on',
  Off = 'off',
}

export enum AnalyticsShareButtonType {
  YourStatisticsWithData = 'your_statistics_with_data',
  YourStatisticsNoData = 'your_statistics_no_data',
  CandyWish = 'candy_wish',
  CandyNewBonus = 'candy_new_bonus',
  Faq = 'faq',
}

export enum AnalyticsInfoModalButtonType {
  GotIt = 'got_it',
  Cross = 'cross',
  DarkPlace = 'dark_place',
}

export enum AnalyticsInfoModalType {
  NoAttempts = 'no_attempts',
  OpenedAll = 'opened_all',
  ProjectFinishesSoon = 'project_finishes_soon',
  ProjectFinished = 'project_finished',
}
